module.exports = __webpack_public_path__ + "img/big.09728489.jpg";